/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';
// API
import {
  getRepFilter,
  getSpecialtyFilter,
  getGroupFilter,
  getDoctorFilter,
} from '../../../api/filterOptionsApi';
// Helpers
import {
  filterValue,
  filterMultiValue,
  filterRepOptions,
  filterSpecialtyOptions,
  filterGroupOptions,
  filterDoctorOptions,
} from '../../../helpers/filterFunctions';
import { getProductFilter } from '../../../api/dropdownOptionsApi';
// Context
import useProductAllocationContext from '../context/useProductAllocationContext';

function Filter() {
  const { filterForm, setFilterForm, handleGenerateFilter, handleClearFilter } = useContext(
    useProductAllocationContext,
  );

  const [repOptions, setRepOptions] = useState([]);
  const [mdOptions, setMDOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);

  const loadRepDropdown = async () => {
    const request = {
      department: filterValue(filterForm?.department),
      team: filterValue(filterForm?.team),
      manager_id: filterValue(filterForm?.manager_id),
      md_id: filterValue(filterForm?.md_id),
      group: filterValue(filterForm?.group),
      month: [Number(moment(filterForm?.month_year).format('MM'))],
      years: [Number(moment(filterForm?.month_year).format('YYYY'))],
      keyword: '',
    };
    const reponse = await getRepFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterRepOptions(data);
      setRepOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadMDDropdown = async () => {
    const request = {
      department: filterValue(filterForm?.department),
      team: filterValue(filterForm?.team),
      manager_id: filterValue(filterForm?.manager_id),
      md_id: filterValue(filterForm?.md_id),
      group: filterValue(filterForm?.group),
      rep_id: filterValue(filterForm?.rep_id),
      month: [Number(moment(filterForm?.month_year).format('MM'))],
      years: [Number(moment(filterForm?.month_year).format('YYYY'))],
    };
    const res = await getDoctorFilter(request);
    const { code, data } = res.data;

    if (code === '200') {
      const dropdownValue = filterDoctorOptions(data);
      setMDOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadGroupaDropdown = async () => {
    const request = {
      department: filterValue(filterForm?.department),
      team: filterValue(filterForm?.team),
      manager_id: filterValue(filterForm?.manager_id),
      md_id: filterValue(filterForm?.md_id),
      group: filterValue(filterForm?.group),
      rep_id: filterValue(filterForm?.rep_id),
      month: [Number(moment(filterForm?.month_year).format('MM'))],
      years: [Number(moment(filterForm?.month_year).format('YYYY'))],
    };
    const reponse = await getGroupFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterGroupOptions(data);

      setGroupOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadSpecialtyDropdown = async () => {
    const request = {
      keyword: '',
      department: filterValue(filterForm?.department),
      team: filterValue(filterForm?.team),
      manager_id: filterValue(filterForm?.manager_id),
      md_id: filterValue(filterForm?.md_id),
      group: filterValue(filterForm?.group),
      rep_id: filterValue(filterForm?.rep_id),
      month: [moment(filterForm?.month_year).format('MM')],
      years: [moment(filterForm?.month_year).format('YYYY')],
    };
    const reponse = await getSpecialtyFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterSpecialtyOptions(data);

      setSpecialtyOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const loadProductDropdown = async () => {
    const request = {
      active: 1,
    };
    const reponse = await getProductFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data
        ?.filter((row) => row.product_name !== '')
        .map((row) => ({
          value: row.id,
          label: row.product_name,
        }));

      setProductOptions([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeFrom = (value) => {
    setFilterForm({ ...filterForm, month_year: moment(value).format('YYYY-MM') });
  };

  useEffect(() => {
    loadSpecialtyDropdown();
    loadProductDropdown();
    loadGroupaDropdown();
    loadRepDropdown();
    loadMDDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='rep_id'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MPR' />}
            size='small'
            value={filterForm?.rep_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'rep_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='md_id'
            disableClearable
            fullWidth
            options={mdOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='MD' />}
            size='small'
            value={filterForm?.md_id}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'md_id')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='group'
            disableClearable
            fullWidth
            options={groupOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Group' />}
            size='small'
            value={filterForm?.group}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'group')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='specialty'
            disableClearable
            fullWidth
            options={specialtyOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Specialty' />}
            size='small'
            value={filterForm?.specialty}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'specialty')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='product'
            disableClearable
            fullWidth
            options={productOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Product' />}
            size='small'
            value={filterForm?.product}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'product')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid xs={2}>
          <DatePicker
            label='month_year'
            views={['month', 'year']}
            value={filterForm?.month_year}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => (
              <TextField {...params} label='Month Year' size='small' fullWidth />
            )}
            onChange={(value) => handleChangeFrom(value)}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateFilter}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClearFilter()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
